@if (data.title) {
  <h1 mat-dialog-title>{{ data.title }}</h1>
}

@if (data.enableSearch) {
  <div class="pt-1 pl-3 pr-3">
    <mat-form-field class="w-100">
      <mat-label>{{ 'general.rechercher' | translate }}</mat-label>
      <input matInput [formControl]="filter">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
}

<mat-divider></mat-divider>

<div mat-dialog-content [formGroup]="form">

  @if (filteredItems$ | async; as items) {
    <mat-selection-list class="arc-mat-selection-list"
      formControlName="selection"
      [multiple]="data.multiple"
      [attr.dense]="data.dense ? 'dense':null"
      >
      @for (item of items; track item) {
        <mat-list-option
          [value]="item"
          [togglePosition]="item.avatar ? 'after' : 'before'"
          [disabled]="item.disabled"
          >
          @if (item.avatar) {
            <div matListItemAvatar>
              @if (item.avatar.type === 'text') {
                <div
                  class="avatar-{{ (item.avatar.text + '').charAt(0) }} {{ item.avatar.bgcolor ? 'bg-' + item.avatar.bgcolor:'' }}">
                  {{ item.avatar.text }}
                </div>
              }
              @if (item.avatar.type === 'icon') {
                <mat-icon>{{ item.avatar.icon }}</mat-icon>
              }
            </div>
          }
          <div matListItemTitle>{{ item.label ?? item.value }} </div>
          @if (item.secondLine) {
            <p matListItemLine>{{ item.secondLine }}</p>
          }
        </mat-list-option>
      }
      @if (items.length === 0) {
        <div class="p-3">
          @if (data.noData) {
            <div class="alert alert-light mt-3">
              <div [innerHTML]="data.noData | safeHtml"></div>
            </div>
          }
        </div>
      }
    </mat-selection-list>
  } @else {
    <div>
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (data.helpContent) {
    <div class="alert alert-light mt-3">
      <div [innerHTML]="data.helpContent | safeHtml"></div>
    </div>
  }

  @if (data.dangerContent) {
    <div class="alert alert-danger mt-3">
      <div [innerHTML]="data.dangerContent | safeHtml"></div>
    </div>
  }

</div>

<mat-divider></mat-divider>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null">{{ 'general.annuler' | translate }}</button>
  <button mat-flat-button color="accent"
    [disabled]="!form.valid"
    [mat-dialog-close]="form.get('selection')?.value">
    {{ data.buttonLabel ?? ('general.selectionner' | translate) }}
  </button>
</mat-dialog-actions>
